/*
* Utility script for a Search form on an OnCloud TRE Property List.
*/
OC_TRE_search = 
{
	init: function()
	{
		// Setup our UI.
		OC_TRE_search.init_ui();
	}
	,
	init_ui: function()
	{
		
	}
}

jQuery(document).ready(function(jQuery){
		
	console.log('Start TRE Search script');
	OC_TRE_search.init();
		
});